import { hasAuthorization } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { deleteFavoriteByListingId as generatedDeleteFavoriteByListingId } from '@generated/search-bff/controllers/favorites/favorites';

/**
 * Delete a favorite for an account.
 * Requires a valid JWT token in the `apiConfig`.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/favorites/deleteFavoriteByListingId Search API Documentation}
 */
export async function deleteFavoriteByListingId(listingId: string, apiConfig: ApiConfig): Promise<ApiResult<void>> {
  if (!hasAuthorization(apiConfig)) {
    console.warn(
      'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
    );
  }

  try {
    const response = await generatedDeleteFavoriteByListingId(listingId, apiConfig);
    return {
      status: 'success',
      data: response,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
